var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11284_19307",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.208008,
    y: 0.736328,
    width: 22.9194,
    height: 22.9194,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11284_19307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3775 19.8832L12.8625 14.3921C12.3851 14.79 11.8359 15.1003 11.2152 15.3232C10.5945 15.546 9.95783 15.6574 9.30526 15.6574C7.66589 15.6574 6.28118 15.0924 5.15113 13.9623C4.02108 12.8323 3.45605 11.4476 3.45605 9.80819C3.45605 8.18474 4.02108 6.80385 5.15113 5.66552C6.28118 4.52783 7.66589 3.95898 9.30526 3.95898C10.9287 3.95898 12.3055 4.52401 13.4355 5.65406C14.5656 6.78411 15.1306 8.16882 15.1306 9.80819C15.1306 10.4926 15.0192 11.1452 14.7964 11.7659C14.5735 12.3866 14.2711 12.9278 13.8891 13.3893L19.4041 18.9043C19.5314 19.0316 19.5951 19.1908 19.5951 19.3818C19.5951 19.5728 19.5235 19.7399 19.3802 19.8832C19.237 20.0264 19.066 20.098 18.8674 20.098C18.6681 20.098 18.5048 20.0264 18.3775 19.8832ZM9.30526 14.2249C10.5308 14.2249 11.5695 13.7952 12.4213 12.9357C13.2725 12.0763 13.6981 11.0337 13.6981 9.80819C13.6981 8.58265 13.2725 7.54013 12.4213 6.68066C11.5695 5.82118 10.5308 5.39144 9.30526 5.39144C8.0638 5.39144 7.01747 5.82118 6.16627 6.68066C5.31443 7.54013 4.88851 8.58265 4.88851 9.80819C4.88851 11.0337 5.31443 12.0763 6.16627 12.9357C7.01747 13.7952 8.0638 14.2249 9.30526 14.2249Z",
    fill: "#333333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.0a58d4651134c6d44b90f59c86f08418.svg";
export { ForwardRef as ReactComponent };